import { render, staticRenderFns } from "./CountryCode.vue?vue&type=template&id=00234aa4&scoped=true&"
import script from "./CountryCode.vue?vue&type=script&lang=js&"
export * from "./CountryCode.vue?vue&type=script&lang=js&"
import style0 from "./CountryCode.vue?vue&type=style&index=0&id=00234aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00234aa4",
  null
  
)

export default component.exports